import { render, staticRenderFns } from "./SystemNotification.vue?vue&type=template&id=6b655599&scoped=true"
import script from "./SystemNotification.vue?vue&type=script&lang=js"
export * from "./SystemNotification.vue?vue&type=script&lang=js"
import style0 from "./SystemNotification.vue?vue&type=style&index=0&id=6b655599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b655599",
  null
  
)

export default component.exports